<template>
    <button type="button" @click.stop.prevent="connectDisconnect" :class="{
                'float-end': true, btn:true, 'btn-sm': true,
                'btn-success': connected === false,
                'btn-danger': connected === true
            }" :title="enableRequired ? enableHint : null">
        {{ label }}
    </button>
</template>

<style>

</style>

<script>
    import {mapGetters} from 'vuex'
    import {hasParameterToken} from '@/services/ThetalakeParameterToken'
    export default {
        props: ['service', 'team', 'beforeAuth'],
        computed: {
            connected() { return !!this.service && !!this.service.isConnected(this.team) },
            ...mapGetters({
                vendor: 'vendor',
                afterOauthData: 'afterOauthData'
            }),
            /**
             * DEV-2843: Theta Lake uses a server-initiated OAuth flow, so before we can
             * authorize we need a `parameter_token` that only their server can give us.
             * Until we have one the button offers **Enable**, which sends the user to Theta
             * Lake to enable our application; they come back with the token and the button
             * becomes the usual Connect.
             *
             * Deliberately keyed off the service's apiName rather than a new prop, so every
             * existing caller (Mailchimp, HubSpot, Sniply…) keeps its two-state behaviour
             * with no change at the call site.
             */
            enableRequired() {
                return !this.connected
                    && !!this.service
                    && this.service.apiName === 'thetalake'
                    && !hasParameterToken();
            },
            enableHint() {
                return 'Theta Lake requires you to enable UpContent from their portal first. '
                    + 'You will be returned here to finish connecting.';
            },
            label() {
                if (this.connected) return 'Disconnect';
                return this.enableRequired ? 'Enable' : 'Connect';
            }
        },
        methods: {
            async connectDisconnect() {
                if (this.connected) {
                    this.service.disconnect(this.team);
                } else if (this.enableRequired) {
                    // Send the user to Theta Lake to enable the application. Their portal is
                    // where the integration is created, which is what produces the
                    // parameter_token and the redirect back to our login URL.
                    window.open(this.thetalakeEnableUrl(), '_blank', 'noopener');
                } else {
                    if (this.beforeAuth) await this.beforeAuth();
                    let iframed = this.vendor === 'hootsuite'
                    setTimeout(() => this.service.connect(this.team, { iframed, afterOauthData: this.afterOauthData }), 5);
                }
            },
            thetalakeEnableUrl() {
                // TODO(DEV-2843): this must become the *customer's own* Theta Lake tenant.
                //
                // Enablement happens in the customer's tenant app (`<tenant>.thetalake.ai`),
                // NOT on developer-preview.thetalake.ai — that is our developer portal,
                // where UpContent registers its application, and a customer has no account
                // on it. An earlier version of this method pointed there, which would have
                // sent every customer somewhere they cannot sign in.
                //
                // Two things block doing this properly, both open with Theta Lake:
                //   1. We have no source for a given customer's tenant URL. Options are to
                //      capture it once on the integration, or to drop the redirect entirely
                //      and show instructions instead.
                //   2. We have not found the screen that enables a registered third-party
                //      application. `Add New Integration` under Policies -> Content Source
                //      -> Collaboration Platforms does not list UpContent, and integration
                //      settings carry no application association.
                //
                // Until both are answered this hardcodes our own preview tenant, deep-linked
                // to the integrations area, so the flow can be exercised end to end.
                // Overridable via env so it can be repointed without a deploy.
                // See tech spec -> Open Questions.
                return process.env.VUE_APP_THETALAKE_PORTAL_URL
                    || 'https://preview1.thetalake.ai/#/policy-management/integrations/conferencing';
            }
        }
    }
</script>
